// Assistant translations for integration with i18next
const translations = {
  'en-US': {
    assistant: {
      browser_welcome: 'Kickstart your experience with CIQ agents. Choose an agent to get started.',
      untitled_chat: 'Untitled chat',
      agents: {
        'planexecution.assistant.plan_document_agent': {
          name: 'Plan docs explainer',
          short_description: 'Comprehensive breakdowns of your plan documents',
          medium_description: 'Comprehensive breakdowns of your plan documents.',
          prompts: [
            'Give me a high level overview of my plan doc',
            'How much commission would I earn on a $500K deal?',
            'Explain how accelerators work in my plan',
          ],
        },
        'payouts.assistant.payouts_info_agent': {
          name: 'Payout statement explainer',
          short_description: 'Get help understanding a payout statement',
          medium_description: 'Get help understanding a payout statement.',
          prompts: [
            'What are my total earnings and what are they made of?',
            'What share of my total payout was SPIF?',
            'Show me which deals contributed the most to my payout.',
          ],
        },
        'worksheets.modeling.plan_comprehension': {
          name: 'Plan Comprehension',
          short_description: 'Understand commission plan structure and calculations',
          medium_description:
            'Understand how commission calculations work, trace dependencies, and analyze formula logic.',
          prompts: ['Explain this formula', 'What depends on this column?', 'Show me the calculation flow'],
        },
        'catalyst.ml.training_run_explainer': {
          name: 'ML Training Explainer',
          short_description: 'Understand machine learning training runs and models',
          medium_description:
            'Analyze ML training performance, understand model behavior, and optimize training processes.',
          prompts: [
            'Explain the results of my latest training run',
            'Why is my model accuracy not improving?',
            'Help me understand the feature importance in my model',
          ],
        },
        'catalyst.ml.prediction_explainer': {
          name: 'ML Prediction Explainer',
          short_description: 'Understand machine learning predictions and insights',
          medium_description: 'Analyze ML model predictions, understand decision factors, and interpret results.',
          prompts: [
            'Why did the model make this prediction?',
            'What factors influenced this forecast?',
            'Help me understand the confidence level of these predictions',
          ],
        },
        'disputes.inquiries': {
          name: 'Inquiries Assistant',
          short_description: 'Handle customer inquiries and disputes',
          medium_description: 'Process customer inquiries, resolve disputes, and provide detailed analysis.',
          prompts: [
            'Help me understand this customer inquiry',
            "What's the best way to resolve this dispute?",
            'Analyze the patterns in recent inquiries',
          ],
        },
        'payee.assistant.payee_agent': {
          name: 'Payee Assistant',
          short_description: 'Comprehensive payee support and guidance',
          medium_description: 'Get help with payee-related questions, commission calculations, and plan understanding.',
          prompts: [
            'Explain my commission structure',
            'How do I maximize my earnings this quarter?',
            'Help me understand my performance metrics',
          ],
        },
        'worksheets.kits.transformation': {
          name: 'Data Transformation',
          short_description: 'Data transformation and processing assistance',
          medium_description: 'Help with data transformations, calculations, and worksheet processing.',
          prompts: [
            'Help me transform this data for analysis',
            'Explain how to calculate these metrics',
            'Optimize my data processing workflow',
          ],
        },
        'tq.account_dealer': {
          name: 'Account Dealer',
          short_description: 'Design and refine account-to-territory assignment rules',
          medium_description:
            'Get help configuring Account Dealer rules — filters, distribution methods, optimization, and more.',
          prompts: [
            'Show me the current account dealer configuration for this territory',
            'Help me balance accounts evenly across territories',
            'Help me set up a new account dealer rule for this territory',
          ],
        },
      },
      input_placeholders: {
        message: 'Chat',
        search: 'Search chats',
      },
      button_labels: {
        load_more: 'Load more',
        new_chat: 'New Chat',
        chat: 'Chat',
        history: 'History',
        back: 'Back',
      },
      messages: {
        no_chats: 'No chats yet. Start a new chat and it will appear here.',
        error_loading_chats: 'Error loading chats. Please try again.',
        error_loading_message_history: 'Error loading message history. Please try again.',
        error_creating_conversation: 'Error creating conversation. Please try again.',
        error_sending_message: 'Error sending message. Please try again.',
        thinking: 'Thinking...',
      },
    },
  },
};

export default translations;
